import type {
    Blogger,
    BloggerChartStat,
    BloggerInvitationNode,
} from "../../api/bloggers";

export const formatTelegramUsername = (
    username: string | null | undefined
): string | null => {
    const trimmed = username?.trim();

    if (!trimmed) {
        return null;
    }

    return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
};

const profileName = (
    name: string | null | undefined,
    surname: string | null | undefined
): string | null => {
    const result = [name, surname].filter(Boolean).join(" ").trim();
    return result || null;
};

export const getBloggerLabel = (
    blogger: Pick<Blogger, "display_name" | "user">
): string =>
    blogger.display_name?.trim() ||
    formatTelegramUsername(blogger.user.telegram_username) ||
    profileName(blogger.user.name, blogger.user.surname) ||
    `#${blogger.user.id}`;

export const getChartBloggerLabel = (blogger: BloggerChartStat): string =>
    blogger.display_name?.trim() ||
    formatTelegramUsername(blogger.user.telegram_username) ||
    profileName(blogger.user.name, blogger.user.surname) ||
    `#${blogger.user.id}`;

export const getInvitationNodeLabel = (
    node: BloggerInvitationNode
): string =>
    profileName(node.name, node.surname) ||
    formatTelegramUsername(node.telegram_username) ||
    node.secret_cookie ||
    `#${node.id}`;
